@if (responsiveVideo$ | async; as video) {
  <x-html5-player
    [url]="video.url"
    [width]="video.dimensions.width"
    [height]="video.dimensions.height"
    [autoplay]="true"
    [controls]="false"
    [fluid]="false"
    quality="auto:best"
    crop="fill"
  ></x-html5-player>
}
